import React, { useState, useEffect } from "react";

const Notification = ({
  show,
  type = "success",
  message = "",
  onClose,
  title = "",
}) => {
  const [isVisible, setIsVisible] = useState(show);

  useEffect(() => {
    setIsVisible(show);

    if (show) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose(); // Callback to parent if provided
      }, 30000); // Auto-close after 3 seconds
      return () => clearTimeout(timer); // Cleanup
    }
  }, [show, onClose]);

  // Define styles and icons for different types of notifications
  const notificationStyles = {
    success: {
      background: "#fff",
      icon: "/assets/images/icon/tick.png",
      minWidth: "400px", // Wider popup for clarity
      minHeight: "6rem",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)", // Subtle shadow for depth
      textAlign: "center",
    },
    error: {
      background: "#fff",
      icon: "/assets/images/icon/tick.png",
      minWidth: "400px", // Wider popup for clarity
      minHeight: "6rem",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)", // Subtle shadow for depth
      textAlign: "center",
    },
    warning: {
      background: "#fff",
      icon: "/assets/images/icon/tick.png",
      minWidth: "400px", // Wider popup for clarity
      minHeight: "6rem",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)", // Subtle shadow for depth
      textAlign: "center",
    },
  };

  const style = notificationStyles[type] || notificationStyles.success;

  return (
    <>
      {isVisible && (
        <div
          className=" position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dim background
            zIndex: 1050,
          }}
        >
          <div
            className="rounded py-10 flex-center flex-column"
            style={{
              ...style,
              minWidth: "400px",
              maxWidth: "400px",
              textAlign: "center",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
            }}
          >
            {/* Notification Content */}
            <p className="text-lg fw-bold">{title}</p>
            <span className="  border-top border-gray-400 d-block w-100" />
            <div className="d-flex align-items-center justify-content-center gap-3">
              {/* <img
                src={style.icon}
                alt={`${type} icon`}
                style={{ width: "1.5rem", height: "1.5rem" }}
              /> */}
              <p
                className="m-0"
                style={{ color: style.color, fontSize: "1rem" }}
              >
                {message}
              </p>
            </div>
            <button
              className="btn text-nowrap text-xs text-md-sm mt-4"
              style={{ background: "#194F7D" }}
              onClick={() => {
                setIsVisible(false);
                if (onClose) onClose(); // Notify parent
              }}
            >
              OK
            </button>
            {/* Close Button */}
            {/* <span className=" my-10 border-top border-gray-400px d-block w-100" /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default Notification;
